export interface ModulesConfig {
  expenses: boolean;
  finance: boolean;
}

const FINANCE_DEFAULT_ROLES = new Set([
  "Administrator",
  "Finance",
  "External Finance Vendor",
]);

export function defaultModulesForRole(role = ""): ModulesConfig {
  return {
    expenses: true,
    finance: FINANCE_DEFAULT_ROLES.has(role),
  };
}

export function resolveModulesConfig(
  raw?: Partial<ModulesConfig> | null,
  role = ""
): ModulesConfig {
  const defaults = defaultModulesForRole(role);
  return {
    expenses: raw?.expenses !== undefined ? Boolean(raw.expenses) : defaults.expenses,
    finance: raw?.finance !== undefined ? Boolean(raw.finance) : defaults.finance,
  };
}

export function isExpenseResource(resource: string): boolean {
  return resource === "expenses" || resource === "submit_expense";
}

export function isFinanceResource(resource: string): boolean {
  return (
    resource === "funding_buckets" ||
    resource === "billable_line_items" ||
    resource === "invoicing" ||
    resource === "reports"
  );
}
